import type { FC } from "react";

import { TFieldProps } from "@/ui/components/form/Field";

export const Field: FC<TFieldProps> = (
  {
    className,
    children,
    ...props
  },
) => {

  return (
    <label
      {...props}
      className={className}
    >
      { children }
    </label>
  );
};

Field.displayName = "Field";
